// // import React, { useState } from 'react';
// // import Select from 'react-select';
// // import { useTranslation } from 'react-i18next';
// // import useGetItemsList from '@hooks/INV/MasterItems/useGetItemsList';
// // import { type TransactionsLinesList } from '@store/Sales/SalesInvoices/SalesInvoicesModels';
// // import Loading from '@components/Shared/Loader/Loading';
// // import useGetUnitsOfMeasureList from '@hooks/INV/useGetUnitsOfMeasureList';

// // interface LinesProps {
// //   LinesList: any[];
// // }

// // const InvoiceLines: React.FC<LinesProps> = ({ LinesList }) => {
// //   //________________________________________________________________

// //   const { i18n, t } = useTranslation();
// //   const { ItemsOptions, loading, error } = useGetItemsList();

// //   const [Lines, setLines] = useState<TransactionsLinesList[]>(LinesList || []);

// //   const { UnitsOfMeasureList, loading: loading2, error: error2 } = useGetUnitsOfMeasureList();

// //   return (
// //     <>
// //       <Loading loading={loading || loading2} error={error || error2}>
// //         <div className='mb-3'>
// //           {/* <div className="row">
// //             <div className="col-lg-3  ">
// //               <div className="form-group mb-3 rounded-4 p-2 bg-inverse bg-opacity-10">
// //                 <label className="fw-bold">{t('Total')} : </label>
// //                 <div className="d-flex justify-content-center">
// //                   <div className="text-theme fs-4 fw-bold">{calculateTotalSum()}</div>
// //                 </div>
// //               </div>
// //             </div>

// //             <div className="col-lg-3"></div>
// //             <div className="col-lg-6 text-end "></div>
// //           </div> */}

// //           {Lines?.length > 0 && (
// //             <div className=''>
// //               <div className={`table-responsive rounded-2 text-center `}>
// //                 <table className='table table-borderless  table-hover mb-0 '>
// //                   <thead className='bg-theme bg-opacity-30'>
// //                     <tr>
// //                       <th className='align-middle' style={{ width: '2%' }}>
// //                         #
// //                       </th>
// //                       <th className='align-middle' style={{ width: '30%' }}>
// //                         {t('اسم الصنف')}
// //                       </th>
// //                       <th className='align-middle' style={{ width: '15%' }}>
// //                         {t('الوحدة')}
// //                       </th>
// //                       <th className='align-middle' style={{ width: '5%' }}>
// //                         {t('الكمية')}
// //                       </th>
// //                       <th className='align-middle' style={{ width: '5%' }}>
// //                         {t('السعر')}
// //                       </th>
// //                       <th className='align-middle' style={{ width: '5%' }}>
// //                         {t('نسبة الخصم')}
// //                       </th>
// //                       <th className='align-middle' style={{ width: '5%' }}>
// //                         {t('قيمة الخصم')}
// //                       </th>
// //                       <th className='align-middle' style={{ width: '5%' }}>
// //                         {t('VAT %')}
// //                       </th>
// //                       <th className='align-middle' style={{ width: '5%' }}>
// //                         {t('VAT')}
// //                       </th>
// //                       <th className='align-middle' style={{ width: '5%' }}>
// //                         {t('Total')}
// //                       </th>
// //                       <th className='align-middle' style={{ width: '20%' }}>
// //                         {t('الوصف')}
// //                       </th>
// //                     </tr>
// //                   </thead>
// //                   <tbody className='fw-bold'>
// //                     {Lines.slice()
// //                       .reverse()
// //                       ?.map((line, index) => {
// //                         const Index = Lines?.length - 1 - index;

// //                         return (
// //                           <tr key={index}>
// //                             <td className='align-middle bg-theme bg-opacity-30'>{Lines?.length - index}</td>
// //                             <td className='align-middle'>
// //                               <Select
// //                                 isDisabled
// //                                 classNamePrefix='react-select'
// //                                 className='w-100'
// //                                 isSearchable
// //                                 isClearable
// //                                 // options={ItemsOptions}
// //                                 options={ItemsOptions?.filter(f => !Lines.some(line => line.itemId === f.value))}
// //                                 value={
// //                                   line.itemId === null
// //                                     ? null
// //                                     : ItemsOptions?.find(option => option.value === line.itemId)
// //                                 }
// //                                 placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
// //                                 menuPortalTarget={document.body}
// //                                 styles={{
// //                                   menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
// //                                 }}
// //                               />
// //                             </td>
// //                             <td className='align-middle'>
// //                               <select disabled className='form-select text-center' value={line.uom || ''}>
// //                                 <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
// //                                 {UnitsOfMeasureList?.map((item, idx) => (
// //                                   <option key={++idx} value={item.id}>
// //                                     {i18n.language === 'en' ? item.name : item.name2}
// //                                   </option>
// //                                 ))}
// //                               </select>
// //                             </td>
// //                             <td className='align-middle'>
// //                               <input
// //                                 readOnly
// //                                 type='text'
// //                                 autoComplete='off'
// //                                 className='form-control text-center px-0'
// //                                 value={line.qty}
// //                                 onInput={e => {
// //                                   // إلغاء أي إدخال غير رقمي يدويًا
// //                                   const input = e.target as HTMLInputElement;
// //                                   input.value = input.value.replace(/[^0-9]/g, '');
// //                                 }}
// //                               />
// //                             </td>
// //                             <td className='align-middle'>
// //                               <input
// //                                 readOnly
// //                                 type='text'
// //                                 autoComplete='off'
// //                                 className='form-control text-center px-0'
// //                                 // size={line.price.toString()?.length || 1}
// //                                 value={line.price}
// //                                 onInput={e => {
// //                                   // إلغاء أي إدخال غير رقمي يدويًا
// //                                   const input = e.target as HTMLInputElement;
// //                                   input.value = input.value.replace(/[^0-9]/g, '');
// //                                 }}
// //                               />
// //                             </td>
// //                             <td className='align-middle'>
// //                               <input
// //                                 readOnly
// //                                 type='text'
// //                                 autoComplete='off'
// //                                 className='form-control text-center px-0'
// //                                 value={line.discountRate}
// //                                 onInput={e => {
// //                                   // إلغاء أي إدخال غير رقمي يدويًا
// //                                   const input = e.target as HTMLInputElement;
// //                                   input.value = input.value.replace(/[^0-9]/g, '');
// //                                 }}
// //                               />
// //                             </td>
// //                             <td className='align-middle'>{line.discountAmount}</td>
// //                             <td className='align-middle'>
// //                               <input
// //                                 readOnly
// //                                 type='text'
// //                                 autoComplete='off'
// //                                 className='form-control text-center px-0'
// //                                 value={line.vatRate}
// //                                 onInput={e => {
// //                                   // إلغاء أي إدخال غير رقمي يدويًا
// //                                   const input = e.target as HTMLInputElement;
// //                                   input.value = input.value.replace(/[^0-9]/g, '');
// //                                 }}
// //                               />
// //                             </td>
// //                             <td className='align-middle'>{line.vatAmount}</td>
// //                             <td className='align-middle'>{line.total}</td>
// //                             <td className='align-middle'>
// //                               <input
// //                                 readOnly
// //                                 type='text'
// //                                 autoComplete='off'
// //                                 className='form-control '
// //                                 value={line.description}
// //                               />
// //                             </td>
// //                           </tr>
// //                         );
// //                       })}
// //                   </tbody>
// //                 </table>
// //               </div>
// //             </div>
// //           )}
// //         </div>
// //       </Loading>
// //     </>
// //   );
// // };

// // export default InvoiceLines;


// // InvoiceLines.tsx (Display Only - POLines Style)
// import React, { useEffect, useMemo, useRef, useState } from 'react';
// import { useTranslation } from 'react-i18next';
// import Loading from '@components/Shared/Loader/Loading';
// import { Card } from '@components/card/card';

// import { fetchItemsWithUomLookup, type ItemWithUomRow } from '@pages/INV/lookups/itemsWithUomLookup.api';

// type ItemType = 'InventoryItem' | 'ExpenseItem' | 'FixedAssetItem' | 'ServiceItem' | 'UndefinedItem';
// const DEFAULT_ITEM_TYPE: ItemType = 'InventoryItem';

// interface LinesProps {
//   LinesList: any[];
//   inventoryId?: string | null; // ✅ optional (fallback to LinesList[0]?.inventoryId)
//   maxTableHeight?: string;
// }

// const chunk = <T,>(arr: T[], size: number) => {
//   const out: T[][] = [];
//   for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
//   return out;
// };

// const clamp = (n: number, min: number, max: number) => Math.max(min, Math.min(n, max));

// const formatNumber = (value: any, decimals = 2) =>
//   new Intl.NumberFormat('en-US', {
//     minimumFractionDigits: decimals,
//     maximumFractionDigits: decimals
//   }).format(Number(value || 0));

// const InvoiceLines: React.FC<LinesProps> = ({ LinesList, inventoryId: inventoryIdProp, maxTableHeight = '500px' }) => {
//   const { i18n, t } = useTranslation();

//   const [Lines] = useState<any[]>(LinesList || []);

//   // ✅ inventoryId resolution
//   const inventoryId: string | null = inventoryIdProp ?? Lines?.[0]?.inventoryId ?? null;

//   // ✅ details map (itemId|uom) -> row
//   const [detailsMap, setDetailsMap] = useState<Map<string, ItemWithUomRow>>(new Map());
//   const [detailsLoading, setDetailsLoading] = useState(false);
//   const [detailsError, setDetailsError] = useState<any>(null);
//   const abortRef = useRef<AbortController | null>(null);

//   const getInfo = (line: any) => {
//     if (!line?.itemId || !line?.uom) return null;
//     return detailsMap.get(`${line.itemId}|${line.uom}`) || null;
//   };

//   const getItemNameForLine = (line: any) => {
//     const info = getInfo(line);
//     const isEn = i18n.language === 'en';
//     const name = isEn ? info?.name || info?.name2 : info?.name2 || info?.name;
//     return name || line?.description || (line?.itemId ? `ID: ${line.itemId}` : '');
//   };

//   const getUomNameForLine = (line: any) => {
//     const info = getInfo(line);
//     const isEn = i18n.language === 'en';
//     const uomName = isEn
//       ? info?.unitOfMeasureName || info?.unitOfMeasureName2
//       : info?.unitOfMeasureName2 || info?.unitOfMeasureName;
//     return uomName || '';
//   };

//   const getUomFactorForLine = (line: any) => {
//     const info = getInfo(line);
//     return (info as any)?.uomFactor ?? '';
//   };

//   // ✅ Only refetch when item/uom/type change (not numbers)
//   const linesKey = useMemo(() => {
//     return (Lines || [])
//       .map(l => `${l?.itemType || DEFAULT_ITEM_TYPE}:${l?.itemId || ''}:${l?.uom || ''}`)
//       .join('|');
//   }, [Lines]);

//   // ✅ Load missing details similar to POLines
//   useEffect(() => {
//     const run = async () => {
//       setDetailsError(null);

//       if (!inventoryId) return;

//       const valid = (Lines || []).filter(l => l?.itemId && l?.uom);
//       if (!valid.length) return;

//       const missingByType = new Map<string, Set<string>>();
//       for (const l of valid) {
//         const key = `${l.itemId}|${l.uom}`;
//         if (detailsMap.has(key)) continue;

//         const type = String(l.itemType || DEFAULT_ITEM_TYPE);
//         if (!missingByType.has(type)) missingByType.set(type, new Set());
//         missingByType.get(type)!.add(String(l.itemId));
//       }

//       if (missingByType.size === 0) return;

//       abortRef.current?.abort();
//       abortRef.current = new AbortController();

//       setDetailsLoading(true);
//       try {
//         const merged = new Map(detailsMap);

//         for (const [type, idsSet] of missingByType.entries()) {
//           const itemIds = Array.from(idsSet);

//           for (const idsChunk of chunk(itemIds, 200)) {
//             const resp = await fetchItemsWithUomLookup(
//               { InventoryId: inventoryId, Scope: 1, WithLastPrice: true },
//               { pageIndex: 1, pageSize: 3000, itemType: type, itemIds: idsChunk } as any,
//               abortRef.current.signal
//             );

//             for (const r of resp.data?.data || []) {
//               merged.set(`${r.itemId}|${r.unitOfMeasure}`, r);
//             }
//           }
//         }

//         setDetailsMap(merged);
//       } catch (e: any) {
//         if (e?.name !== 'CanceledError' && e?.code !== 'ERR_CANCELED') {
//           console.error(e);
//           setDetailsError(e);
//         }
//       } finally {
//         setDetailsLoading(false);
//       }
//     };

//     run();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [inventoryId, linesKey]);

//   // ✅ Total sum (optional header)
//   const totalSum = useMemo(() => {
//     const sum = (Lines || []).reduce((s, l) => s + Number(l?.total || 0), 0);
//     return formatNumber(sum, 2);
//   }, [Lines]);

//   return (
//     <>
//       <Loading loading={detailsLoading} error={detailsError}>
//         <div className='mb-3'>
//           {/* Header (optional) */}
//           <Card>
//             <div className='bg-inverse bg-opacity-10 p-3 rounded-0'>
//               <div className='d-flex flex-wrap gap-4 justify-content-between align-items-center'>
//                 <div className='d-flex gap-2 align-items-center'>
//                   <span className='fw-bold'>{t('Total')}:</span>
//                   <span className='text-theme fs-5 fw-bold'>{totalSum}</span>
//                 </div>

//                 {!inventoryId && (
//                   <small className='text-muted'>
//                     {i18n.language === 'en'
//                       ? 'InventoryId not provided. Showing IDs only.'
//                       : 'لم يتم تمرير InventoryId، سيتم العرض بالـ IDs فقط.'}
//                   </small>
//                 )}
//               </div>
//             </div>
//           </Card>

//           {Lines?.length > 0 && (
//             <div className='mt-2'>
//               <div className='table-responsive rounded-2 text-center'>
//                 <div style={{ maxHeight: maxTableHeight, overflow: 'auto' }}>
//                   <table className='table table-borderless table-hover mb-0' style={{ minWidth: 1400 }}>
//                     <thead className='bg-theme bg-opacity-30'>
//                       <tr>
//                         <th className='align-middle' style={{ width: '4%' }}>
//                           #
//                         </th>

//                         {/* ✅ نفس شكل POLines */}
//                         <th className='align-middle' style={{ width: '45%' }}>
//                           {t('الصنف / الباركود')}
//                         </th>

//                         <th className='align-middle' style={{ width: '12%' }}>
//                           {t('الوحدة')}
//                         </th>

//                         <th className='align-middle' style={{ width: '8%' }}>
//                           {t('الكمية')}
//                         </th>

//                         <th className='align-middle' style={{ width: '8%' }}>
//                           {t('السعر')}
//                         </th>

//                         <th className='align-middle' style={{ width: '8%' }}>
//                           {t('نسبة الخصم')}
//                         </th>

//                         <th className='align-middle' style={{ width: '8%' }}>
//                           {t('قيمة الخصم')}
//                         </th>

//                         <th className='align-middle' style={{ width: '6%' }}>
//                           {t('VAT %')}
//                         </th>

//                         <th className='align-middle' style={{ width: '6%' }}>
//                           {t('VAT')}
//                         </th>

//                         <th className='align-middle' style={{ width: '8%' }}>
//                           {t('Total')}
//                         </th>

//                         {/* <th className='align-middle' style={{ width: '17%' }}>
//                           {t('الوصف')}
//                         </th> */}
//                       </tr>
//                     </thead>

//                     <tbody className='fw-bold'>
//                       {Lines.slice()
//                         .reverse()
//                         .map((line, revIndex) => {
//                           const index = Lines.length - 1 - revIndex;

//                           const info = getInfo(line);
//                           const itemName = line.itemId ? getItemNameForLine(line) : '';
//                           const uomName = line.itemId ? getUomNameForLine(line) : '';
//                           const uomFactor = line.itemId ? getUomFactorForLine(line) : '';
//                           const barcode = (info as any)?.barcode || '';

//                           const barcodeDisplay = line.itemId
//                             ? barcode ||
//                               (detailsLoading ? (i18n.language === 'en' ? 'Loading...' : '...جاري التحميل') : '-')
//                             : '-';

//                           const uomDisplay =
//                             uomName ||
//                             (detailsLoading
//                               ? i18n.language === 'en'
//                                 ? 'Loading...'
//                                 : '...جاري التحميل'
//                               : line.uom
//                               ? '-'
//                               : '-');

//                           return (
//                             <tr key={revIndex}>
//                               <td className='align-middle bg-theme bg-opacity-30'>{Lines.length - revIndex}</td>

//                               {/* ✅ Item/Barcode cell like POLines (display only) */}
//                               <td className='align-middle text-start'>
//                                 <div className='p-2 border border-theme bg-body'>
//                                   <div className='d-flex align-items-start gap-2'>
//                                     <div className='flex-grow-1' style={{ minWidth: 0 }}>
//                                       <span className='fw-bold text-truncate d-block'>
//                                         {itemName ||
//                                           (detailsLoading
//                                             ? i18n.language === 'en'
//                                               ? 'Loading...'
//                                               : '...جاري التحميل'
//                                             : line?.itemId
//                                             ? `ID: ${line.itemId}`
//                                             : '-')}
//                                       </span>

//                                       <small className='text-muted d-block'>
//                                         {t('الوحدة')}: <span className='fw-bold text-theme'>{uomDisplay || '-'}</span>
//                                         <span className='mx-2'>•</span>
//                                         {t('الشد')}: <span className='fw-bold text-theme'>{uomFactor || '-'}</span>
//                                         <span className='mx-2'>•</span>
//                                         {t('باركود')}: <span className='fw-bold'>{barcodeDisplay}</span>
//                                       </small>
//                                     </div>
//                                   </div>
//                                 </div>
//                               </td>

//                               <td className='align-middle text-center'>{uomName || '-'}</td>
//                               <td className='align-middle text-center'>{formatNumber(line.qty, 2)}</td>
//                               <td className='align-middle text-center'>{formatNumber(line.price, 2)}</td>
//                               <td className='align-middle text-center'>{formatNumber(line.discountRate, 2)}</td>
//                               <td className='align-middle text-center'>{formatNumber(line.discountAmount, 2)}</td>
//                               <td className='align-middle text-center'>{formatNumber(clamp(Number(line.vatRate || 0), 0, 100), 2)}</td>
//                               <td className='align-middle text-center'>{formatNumber(line.vatAmount, 2)}</td>
//                               <td className='align-middle text-center text-theme fw-bold'>
//                                 {formatNumber(line.total, 2)}
//                               </td>
//                               {/* <td className='align-middle'>
//                                 <div className='text-start'>{line.description || '-'}</div>
//                               </td> */}
//                             </tr>
//                           );
//                         })}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       </Loading>
//     </>
//   );
// };

// export default InvoiceLines;

import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Loading from '@components/Shared/Loader/Loading';
import { Card } from '@components/card/card';

import { fetchItemsWithUomLookup, type ItemWithUomRow } from '@pages/INV/lookups/itemsWithUomLookup.api';

type ItemType = 'InventoryItem' | 'ExpenseItem' | 'FixedAssetItem' | 'ServiceItem' | 'UndefinedItem';
const DEFAULT_ITEM_TYPE: ItemType = 'InventoryItem';

interface LinesProps {
  LinesList: any[];
  inventoryId?: string | null; // optional (fallback to LinesList[0]?.inventoryId)
  maxTableHeight?: string;
}

const chunk = <T,>(arr: T[], size: number) => {
  const out: T[][] = [];
  for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
  return out;
};

const clamp = (n: number, min: number, max: number) => Math.max(min, Math.min(n, max));

const formatNumber = (value: any, decimals = 2) =>
  new Intl.NumberFormat('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  }).format(Number(value || 0));

const round2 = (v: any) => {
  const n = Number(v || 0);
  return Math.round((n + Number.EPSILON) * 100) / 100;
};

const InvoiceLines: React.FC<LinesProps> = ({ LinesList, inventoryId: inventoryIdProp, maxTableHeight = '500px' }) => {
  const { i18n, t } = useTranslation();

  const lines = useMemo<any[]>(() => (Array.isArray(LinesList) ? LinesList : []), [LinesList]);

  // ✅ inventoryId resolution
  const inventoryId: string | null = inventoryIdProp ?? lines?.[0]?.inventoryId ?? null;

  // ✅ details map (itemId|uom) -> row
  const [detailsMap, setDetailsMap] = useState<Map<string, ItemWithUomRow>>(new Map());
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [detailsError, setDetailsError] = useState<any>(null);
  const abortRef = useRef<AbortController | null>(null);

  const getInfo = (line: any) => {
    if (!line?.itemId || !line?.uom) return null;
    return detailsMap.get(`${line.itemId}|${line.uom}`) || null;
  };

  const getItemNameForLine = (line: any) => {
    const info = getInfo(line);
    const isEn = i18n.language === 'en';
    const name = isEn ? info?.name || info?.name2 : info?.name2 || info?.name;

    // fallback order: name -> line.itemName -> line.description -> ID
    return (
      name ||
      line?.itemName ||
      line?.description ||
      (line?.itemId ? `ID: ${line.itemId}` : '')
    );
  };

  const getUomNameForLine = (line: any) => {
    const info = getInfo(line);
    const isEn = i18n.language === 'en';
    const uomName = isEn
      ? info?.unitOfMeasureName || info?.unitOfMeasureName2
      : info?.unitOfMeasureName2 || info?.unitOfMeasureName;

    return uomName || line?.uomName || line?.unitOfMeasureName || '';
  };

  // ✅ Only refetch when identity changes (not numbers)
  const linesKey = useMemo(() => {
    return (lines || [])
      .map(l => `${l?.itemType || DEFAULT_ITEM_TYPE}:${l?.itemId || ''}:${l?.uom || ''}`)
      .join('|');
  }, [lines]);

  // ✅ Load missing details like AddReturnLines
  useEffect(() => {
    const run = async () => {
      setDetailsError(null);

      if (!inventoryId) return;

      const valid = (lines || []).filter(l => l?.itemId && l?.uom);
      if (!valid.length) return;

      const missingByType = new Map<string, Set<string>>();

      for (const l of valid) {
        const key = `${l.itemId}|${l.uom}`;
        if (detailsMap.has(key)) continue;

        const type = String(l.itemType || DEFAULT_ITEM_TYPE);
        if (!missingByType.has(type)) missingByType.set(type, new Set());
        missingByType.get(type)!.add(String(l.itemId));
      }

      if (missingByType.size === 0) return;

      abortRef.current?.abort();
      abortRef.current = new AbortController();

      setDetailsLoading(true);
      try {
        const merged = new Map(detailsMap);

        for (const [type, idsSet] of missingByType.entries()) {
          const itemIds = Array.from(idsSet);

          for (const idsChunk of chunk(itemIds, 200)) {
            const resp = await fetchItemsWithUomLookup(
              { InventoryId: inventoryId, Scope: 1, WithLastPrice: true },
              { pageIndex: 1, pageSize: 3000, itemType: type, itemIds: idsChunk } as any,
              abortRef.current.signal
            );

            for (const r of resp.data?.data || []) {
              merged.set(`${r.itemId}|${r.unitOfMeasure}`, r);
            }
          }
        }

        setDetailsMap(merged);
      } catch (e: any) {
        if (e?.name !== 'CanceledError' && e?.code !== 'ERR_CANCELED') {
          console.error(e);
          setDetailsError(e);
        }
      } finally {
        setDetailsLoading(false);
      }
    };

    run();

    return () => {
      abortRef.current?.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inventoryId, linesKey]);

  // =========================
  // ✅ Totals (Display Only)
  // =========================
  const totals = useMemo(() => {
    const net = (lines || []).reduce((s, l) => s + Number(l?.total ?? 0), 0);
    const vat = (lines || []).reduce((s, l) => s + Number(l?.vatAmount ?? 0), 0);

    // prefer totalWithVat if present, else (total + vatAmount)
    const gross = (lines || []).reduce((s, l) => {
      const tv = l?.totalWithVat ?? l?.totalWithVAT ?? l?.totalWithTax;
      if (tv != null) return s + Number(tv || 0);
      const base = Number(l?.total ?? 0);
      const v = Number(l?.vatAmount ?? 0);
      return s + (base + v);
    }, 0);

    return {
      linesSubtotal: formatNumber(round2(net), 2),
      vatTotal: formatNumber(round2(vat), 2),
      netTotal: formatNumber(round2(gross), 2)
    };
  }, [lines]);

  return (
    <>
      <Loading loading={false} error={detailsError} Type="Dots">
        {/* ✅ Totals header like AddReturnLines */}
        <Card>
          <div className="bg-inverse bg-opacity-10 p-3 rounded-0">
            <div className="d-flex flex-wrap gap-4 justify-content-between">
              <div className="d-flex gap-2 align-items-center">
                <span className="fw-bold">{t('الإجمالي')}:</span>
                <span className="fw-bold">{totals.linesSubtotal}</span>
              </div>
              <div className="d-flex gap-2 align-items-center">
                <span className="fw-bold">{t('VAT')}:</span>
                <span className="fw-bold text-warning">{totals.vatTotal}</span>
              </div>
              <div className="d-flex gap-2 align-items-center">
                <span className="fw-bold">{t('الصافي')}:</span>
                <span className="text-theme fs-5 fw-bold">{totals.netTotal}</span>
              </div>
            </div>
          </div>
        </Card>

        {/* ✅ Header like AddReturnLines */}
        <div className="card-header">
          <div className="d-flex flex-column flex-md-row justify-content-between gap-3">
            <div className="d-flex align-items-center">
              <i className="fas fa-list fs-5 text-theme me-2"></i>
              <h6 className="mb-0 fw-semibold">
                {t('بنود الفاتورة')}
                <span className="badge bg-theme rounded-pill ms-2">{lines?.length || 0}</span>
              </h6>
            </div>

            <div className="d-flex align-items-center gap-2">
              {detailsLoading && (
                <div className="d-flex align-items-center">
                  <span className="spinner-border spinner-border-sm text-theme me-2"></span>
                  <small className="text-muted">{t('جاري تحميل التفاصيل...')}</small>
                </div>
              )}

              {!inventoryId && (
                <small className="text-muted">
                  {i18n.language === 'en'
                    ? 'InventoryId not provided. Showing fallback names/IDs.'
                    : 'لم يتم تمرير InventoryId، سيتم العرض بالبيانات المتاحة/المعرفات.'}
                </small>
              )}
            </div>
          </div>
        </div>

        <div className="card-body p-0">
          <div className="table-responsive" style={{ maxHeight: maxTableHeight, overflow: 'auto', position: 'relative' }}>
            <table className="table table-hover mb-0" style={{ minWidth: '1650px' }}>
              <thead
                className="shadow fw-bold"
                style={{
                  position: 'sticky',
                  top: 0,
                  zIndex: 101,
                  backdropFilter: 'blur(30px)'
                }}
              >
                <tr>
                  <th
                    className="text-center small shadow"
                    style={{ width: '50px', minWidth: '50px', position: 'sticky', left: 0, zIndex: 101 }}
                  >
                    #
                  </th>

                  <th className="text-center small" style={{ width: '520px', minWidth: '520px' }}>
                    {t('الصنف / الباركود')}
                  </th>

                  <th className="text-center small" style={{ width: '140px', minWidth: '140px' }}>
                    {t('الوحدة')}
                  </th>

                  <th className="text-center small" style={{ width: '120px', minWidth: '120px' }}>
                    {t('الكمية')}
                  </th>

                  <th className="text-center small" style={{ width: '110px', minWidth: '110px' }}>
                    {t('السعر')}
                  </th>

                  <th className="text-center small" style={{ width: '110px', minWidth: '110px' }}>
                    {t('نسبة الخصم')}
                  </th>

                  <th className="text-center small" style={{ width: '110px', minWidth: '110px' }}>
                    {t('قيمة الخصم')}
                  </th>

                  <th className="text-center small" style={{ width: '90px', minWidth: '90px' }}>
                    VAT %
                  </th>

                  <th className="text-center small" style={{ width: '110px', minWidth: '110px' }}>
                    {t('VAT')}
                  </th>

                  <th className="text-center small" style={{ width: '130px', minWidth: '130px' }}>
                    {t('Total')}
                  </th>

                  <th className="text-center small" style={{ width: '260px', minWidth: '260px' }}>
                    {t('الوصف')}
                  </th>
                </tr>
              </thead>

              <tbody>
                {(lines || []).length > 0 ? (
                  (lines || []).map((line: any, index: number) => {
                    const info = getInfo(line);

                    const itemName = line?.itemId ? getItemNameForLine(line) : (line?.description || '');
                    const uomName = line?.itemId ? getUomNameForLine(line) : (line?.uomName || line?.unitOfMeasureName || '');

                    const barcode = (info as any)?.barcode || '';
                    const barcodeDisplay =
                      line?.itemId
                        ? barcode ||
                          line?.barcode ||
                          (detailsLoading ? (i18n.language === 'en' ? 'Loading...' : '...جاري التحميل') : '-')
                        : '-';

                    const qty = Number(line?.qty ?? 0);
                    const price = Number(line?.price ?? 0);
                    const discRate = Number(line?.discountRate ?? 0);
                    const discAmt = Number(line?.discountAmount ?? 0);
                    const vatRate = clamp(Number(line?.vatRate ?? 0), 0, 100);
                    const vatAmount = Number(line?.vatAmount ?? 0);

                    const totalWithVat =
                      line?.totalWithVat ?? line?.totalWithVAT ?? line?.totalWithTax;

                    const total =
                      totalWithVat != null
                        ? Number(totalWithVat || 0)
                        : Number(line?.total ?? 0) + vatAmount;

                    return (
                      <tr key={index}>
                        {/* ✅ # sticky like AddReturnLines */}
                        <td className="text-center align-middle bg-body shadow" style={{ position: 'sticky', left: 0 }}>
                          <span className="badge bg-theme bg-opacity-80 fw-bold" style={{ fontSize: '0.85rem' }}>
                            {index + 1}
                          </span>
                        </td>

                        {/* ✅ item + barcode */}
                        <td className="align-middle">
                          <div className="p-2 border border-theme bg-body">
                            <div className="d-flex align-items-start gap-2">
                              <div className="flex-grow-1" style={{ minWidth: 0 }}>
                                <span className="fw-bold text-truncate d-block">
                                  {itemName ||
                                    (detailsLoading
                                      ? i18n.language === 'en'
                                        ? 'Loading...'
                                        : '...جاري التحميل'
                                      : line?.itemId
                                      ? `ID: ${line.itemId}`
                                      : '-')}
                                </span>

                                <small className="text-muted d-block">
                                  {t('الوحدة')}: <span className="fw-bold text-theme">{uomName || '-'}</span>
                                  <span className="mx-2">•</span>
                                  {t('باركود')}: <span className="fw-bold">{barcodeDisplay}</span>
                                </small>
                              </div>
                            </div>
                          </div>
                        </td>

                        {/* ✅ uom */}
                        <td className="align-middle text-center">
                          <span className="fw-semibold">{uomName || '-'}</span>
                        </td>

                        {/* ✅ qty */}
                        <td className="align-middle text-center">
                          <span className="fw-semibold">{formatNumber(qty, 2)}</span>
                        </td>

                        {/* ✅ price */}
                        <td className="align-middle text-center">
                          <span className="fw-semibold">{formatNumber(price, 2)}</span>
                        </td>

                        {/* ✅ discount rate */}
                        <td className="align-middle text-center">
                          <span className="fw-semibold">{formatNumber(discRate, 2)}</span>
                        </td>

                        {/* ✅ discount amount */}
                        <td className="align-middle text-center">
                          <span className="fw-semibold">{formatNumber(discAmt, 2)}</span>
                        </td>

                        {/* ✅ vat rate */}
                        <td className="align-middle text-center">
                          <span className="fw-semibold">{formatNumber(vatRate, 2)}</span>
                        </td>

                        {/* ✅ vat amount */}
                        <td className="align-middle fw-bold text-warning text-center">
                          {formatNumber(vatAmount, 2)}
                        </td>

                        {/* ✅ total (with VAT) */}
                        <td className="align-middle text-center">
                          <strong className="text-theme fs-6">{formatNumber(total, 2)}</strong>
                        </td>

                        {/* ✅ description */}
                        <td className="align-middle">
                          <div className="text-start small">
                            {line?.notes || line?.description2 || line?.description || '-'}
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={11} className="text-center py-4 text-muted">
                      <i className="fa fa-inbox fa-2x mb-2"></i>
                      <br />
                      {t('لا توجد بنود')}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </Loading>
    </>
  );
};

export default InvoiceLines;
